export const clearFilterElement = (setValue,clear,value) => {
    if(clear && value)
        setValue("")
}